import React, { Component } from 'react';
import SaveTemplate from '../../assets/Save-template.png';
import EditTemplate from '../../assets/Edit-template.png';
import AddNewTemplate from '../../assets/Add-new-template.png';
import urls from '../../custom_libraries/urls';
import { get, post, put, del } from '../../custom_libraries/serverRequests';
import globalVariables from "../../custom_libraries/globalVariables";
import ResetIcon from '../../assets/icons8-reset-24.png';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from "../../assets/icons8-trash-50.png";
import DialogBox from '../DialogBox';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

class CloudStorageTemplates extends Component {
constructor(props) {
        super(props);
        this.state = {
            template_name : '',
            template_list: [{id: "1", name: "Default"}, {id: "2", name: "AWS S3"}, {id: "3", name: "Google Drive"}, {id: "4", name: "Dropbox"}],
            isEditable: false, // Toggle for edit mode
            selectedTemplateID: 1,
            success: false,
            error: false,
            success1: false,
            error1: false,
            // deleteError: false,
            // deleteSuccess: false,
            // deleteCheck1: false,
            // deleteCheck2: false,
            confirmDialog: {
                isOpen: false,
                title: '',
                subtitle: '',
            },
            directory: '',
            q_auth_code: '',
            q_auth_credentials: '',
            selectedRegion: '',
            bucket: '',
            access_key: '',
            secret_key: '',
            isFormFilled: {
            "AWS S3": false,
            "Google Drive": false,
          },
            defaultTemplateData: null,
            defaultTemplateType: '',  // "AWS S3" or "Google Drive"

        }
    }

    componentDidMount() {
        this.handleFetchStorageTemplate();
        this.fetchDefaultTemplateData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.error !== prevState.error ||
            this.state.error1 !== prevState.error1 ||
            this.state.success !== prevState.success ||
            this.state.success1 !== prevState.success1 ||
            this.state.deleteSuccess !== prevState.deleteSuccess ||
            this.state.deleteError !== prevState.deleteError ||
            this.state.deleteCheck1 !== prevState.deleteCheck1 ||
            this.state.deleteCheck2 !== prevState.deleteCheck2
        ) {
            if (
                this.state.error ||
                this.state.error1 ||
                this.state.success ||
                this.state.success1 ||
                this.state.deleteSuccess ||
                this.state.deleteError ||
                this.state.deleteCheck1 ||
                this.state.deleteCheck2
            ) {
                setTimeout(() => {
                    this.setState({
                        error: false,
                        error1: false,
                        success: false,
                        success1: false,
                        deleteError: false,
                        deleteSuccess: false,
                        deleteCheck1: false,
                        deleteCheck2: false
                    });
                }, 3000); // 1 second
            }
        }
    }

    // handleInputChange = (e) => {
    //     this.setState({
    //         [e.target.name]: e.target.value
    //     });
    // }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
        if(this.state.create_new_template===true)
            {
                return
            }
        // If the user selects a template, populate hours and days
        if (name === "template_name") {
            const selectedTemplate = this.state.template_list.find((temp) => temp.id.toString() === value);
            if (selectedTemplate) {
                this.setState({
                    selectedTemplateID: selectedTemplate.id,
                    // template_days: selectedTemplate.days,
                    // template_hd_capacity: selectedTemplate.hd_capacity_alert
                });
            // Load form values when user selects AWS S3
                if (selectedTemplate.name === "AWS S3") {
                    this.handleFetchStorageTemplate();  // fetch again on AWS S3 selection
                }
                if (selectedTemplate.name === "Default") {
                  this.fetchDefaultTemplateData();
                }

            }
        }
    };

    handleFetchStorageTemplate = async() => {

        try{
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            let user_id = localStorage.getItem(globalVariables.USER_ID);
            // let user_type = localStorage.setItem(globalVariables.USER_TYPE)
            //
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            let response = await get(urls.GET_CLOUD_STORAGE_TEMPLATE(user_id), headers );
            response = response.data[0];
            if (response && response.bucket_name) {
                this.setState(prevState => ({
                bucket: response.bucket_name,
                access_key: response.access_key,
                secret_key: response.secret_key,
                selectedRegion: response.region,
                isFormFilled: {
                    ...prevState.isFormFilled,
                    "AWS S3": true
                }
            }));
            } else {
                console.log("No data returned from the API");
                // this.setState({ template_list: [] });
            }
        }

        catch (error) {
            console.error("Error fetching devices from API:", error);
        }
    }


    handleEditTemplate = () => {
        this.setState({
            isEditable: true,
            // create_new_template: false,
         });
    };

    handleSaveTemplate = async() => {
        let post_data = {
            "name" : this.state.template_name,
            "hours" : 0,
            "days" : this.state.template_days,
            "hd_capacity_alert": this.state.template_hd_capacity
        }

        post_data = JSON.stringify(post_data);
        console.log("------post-data in SaveTemplate---", post_data);

        try{
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

            let headers = {
                // 'content-type': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_tocken}`
            }
            let response = await post(urls.HEALTH_RECORDING_POLICY, post_data, headers);
            console.log("API Response:", response)
            if (response && response.status === 200) {
                this.setState(prev => ({
                    success: true,
                    isEditable: false,
                    isFormFilled: {
                        ...prev.isFormFilled,
                        "AWS S3": true
                    }
                }));
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
                this.resetToFetchedData();
            } else {
                console.error("No response returned from the API");
                this.setState({ error: true });
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
                this.resetToFetchedData();
            }
        }

        catch (error) {
            console.error("Error fetching devices from API:", error);
        }
    }

    handleUpdateTemplate = async () => {
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            const {selectedTemplateID} = this.state;
            const updatedTemplate = {
                id: this.state.template_name,
                // hours: this.state.template_hours,
                selectedRegion: '',
                selectedTemplateID: '',
                bucket: '',
                access_key: '',
                secret_key: '',
                // days: this.state.template_days,
                // hd_capacity_alert: this.state.template_hd_capacity
            };
            let post_data = JSON.stringify(updatedTemplate);
            console.log("------post-data in update Template---", post_data);

            // Call API to save updated values
            let headers = {
                'content-type': 'application/json',
                // 'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.MANAGE_HEALTH_RECORDING_POLICY(selectedTemplateID);

            let response = await put(url, post_data, headers);

            if (response.id) {
                console.log("res---",response)
                this.setState({ success1: true });
                // this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            } else {
                console.log("No response returned from the API")
                this.setState({ error1: true });
                this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            }

        } catch (error) {
            console.error("Error saving template:", error);
        }
    };

    handleDelete = async () => {
        const {selectedTemplateID} = this.state
        try {
            // if(selectedTemplateID === 1){
            //     alert("you can not delete default template");
            //     return
            // }
            // if(selectedTemplateID === null ){
            //     alert("please select template first.");
            //     return
            // }
            const url = urls.MANAGE_HEALTH_RECORDING_POLICY(selectedTemplateID);

            let response = await del(url);
            if (response) {
                console.log("res---",response)
                this.setState({ deleteSuccess: true });
                this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            } else {
                console.log("No response returned from the API")
                this.setState({ deleteError: true });
                this.resetToFetchedData();
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000); // 3 seconds delay
            }
        }
        catch (error){
            console.error("Error saving template:", error);
        }
    }

    openDialog = (onConfirm) => {
        const {selectedTemplateID} = this.state
        if(selectedTemplateID === 1){
            // alert("you can not delete default template");
            this.setState({deleteCheck1:true});
            return
        }
        if(selectedTemplateID === null ){
            // alert("please select template first.");
            this.setState({deleteCheck2:true});
            return
        }
        this.setState({
          confirmDialog: {
            isOpen: true,
            title: 'Confirm Action',
            subtitle: "Are you sure, you want to delete this template?",
            onConfirm
          },
        });
      };

    closeDialog = () => {
        this.setState({
          confirmDialog: {
            ...this.state.confirmDialog,
            isOpen: false,
          },
        });
      };

    resetToFetchedData = () => {
        this.setState({
            // create_new_template: false,
            isEditable: false,
            // template_name: '', // Reset or set to fetched template name
            selectedRegion: '',
            selectedTemplateID: '',
            bucket: '',
            access_key: '',
            secret_key: '',
        });
        // Optionally, fetch the data again to ensure the form is up-to-date
        // this.handleFetchTemplate();
    };

  handleSaveAWSCredentials = async () => {
    const { bucket, access_key, secret_key, selectedRegion } = this.state;

    let post_data = {
        "bucket_name": bucket,
        "access_key": access_key,
        "secret_key": secret_key,
        "region": selectedRegion,
    };

    post_data = JSON.stringify(post_data);

    try {
        const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        };

        const response = await post(urls.ADD_AWS_CLOUD_STORAGE_TEMPLATE_INFO, post_data, headers);

        if (response && response.message?.includes("saved successfully")) {
            this.setState({ success: true });
        } else if (response && response.message?.includes("updated successfully")) {
            this.setState({ success1: true });
        }
        else if (response && response.detail?.includes("Credential test failed. Please provide valid bucket/access/secret/region.")) {
            console.error("No response returned from the API");
            this.setState({ error: true });
        }
        else{
          console.log("Error saving AWS credentials:", response);
           this.setState({ error1: true });
        }
    } catch (err) {
        console.error("Error saving AWS credentials:", err);
        // this.setState({ error1: true });
    }
};

  fetchDefaultTemplateData = async () => {
  try {
    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${access_token}`,
    };

    const response = await get(urls.GET_DEFAULT_CLOUD_STORAGE_TEMPLATE, headers);

    // const data = response.data;
    if (response) {
      this.setState({
        defaultTemplateData: response,
        defaultTemplateType: response.storage_type,
      });
    }
  } catch (error) {
    console.error("Error fetching default template:", error);
  }
};



    render(){
        const { template_name, selectedRegion, selectedTemplateID, bucket, access_key, secret_key, template_list,
             isEditable, error, success, error1, success1, deleteError, deleteSuccess, confirmDialog, deleteCheck1,
             deleteCheck2, directory, q_auth_code, q_auth_credentials, isFormFilled, defaultTemplateData, defaultTemplateType} = this.state;
        const regions = [
      {
        name: "United States",
        subRegions: [
          { name: "N. Virginia", code: "us-east-1" },
          { name: "Ohio", code: "us-east-2" },
          { name: "N. California", code: "us-west-1" },
          { name: "Oregon", code: "us-west-2" }
        ]
      },
      {
        name: "Asia Pacific",
        subRegions: [
          { name: "Mumbai", code: "ap-south-1" },
          { name: "Osaka", code: "ap-northeast-3" },
          { name: "Seoul", code: "ap-northeast-2" },
          { name: "Singapore", code: "ap-southeast-1" },
          { name: "Sydney", code: "ap-southeast-2" },
          { name: "Tokyo", code: "ap-northeast-1" }
        ]
      },
      {
        name: "Canada",
        subRegions: [
          { name: "Central", code: "ca-central-1" }
        ]
      },
      {
        name: "Europe",
        subRegions: [
          { name: "Frankfurt", code: "eu-central-1" },
          { name: "Ireland", code: "eu-west-1" },
          { name: "London", code: "eu-west-2" },
          { name: "Paris", code: "eu-west-3" },
          { name: "Stockholm", code: "eu-north-1" }
        ]
      },
      {
        name: "South America",
        subRegions: [
          { name: "São Paulo", code: "sa-east-1" }
        ]
      }
    ];
        return(
            <div style={{ display: 'flex', flexDirection: 'column' }}>

                <div className="side-by-side-container" style={{ flex: '2', marginLeft:'9%', marginTop:'1%', padding: '20px', overflowY: 'auto', gap:'50px' }}>
                    <div className="health-setting-container">
                        <div>
                          { error ? (
                                <Alert severity="error">Credential test failed. Please provide valid bucket/access/secret/region.</Alert>
                          ) : success ? (
                              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                  "All set! New template was saved successfully."
                              </Alert>
                          ) : error1 ? (
                              <Alert severity="error">Server Error! please, Try again.</Alert>
                          ) : success1 ? (
                              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                  "All set! Template info was updated successfully."
                              </Alert>

                          ) : null}
                        </div>
                        <div style={{width:'100%', backgroundColor: "#353d4f"}}>
                            <h4>Cloud Storage Templates</h4>
                            <label>Template Name : </label>
                            <select
                            name="template_name"
                            // placeholder="Enter template name"
                            value={selectedTemplateID}
                            onChange={this.handleInputChange}
                            >

                                    {/* <option value="" disabled>Select Template to view</option> */}
                                {(template_list|| []).map((temp) => (
                                <option key={temp.id} value={temp.id}>
                                    {temp.name}
                                </option>
                            ))}
                            </select>

                            {(() => {
const selectedTemplate = template_list.find(
(temp) => temp.id.toString() === selectedTemplateID?.toString()
);
if (selectedTemplate?.name === "Default" && defaultTemplateData) {
if (defaultTemplateType === "AWS S3") {
return (
<>
<label>Bucket : </label>
<input value={defaultTemplateData.aws_s3?.bucket_name || ''} readOnly />
<label>Access Key : </label>
<input value={defaultTemplateData.aws_s3?.access_key || ''} readOnly />
<label>Secret Key : </label>
<input value={defaultTemplateData.aws_s3?.secret_key || ''} readOnly />
<label>Region : </label>
<input value={defaultTemplateData.aws_s3?.region || ''} readOnly />
</>
);
}

if (defaultTemplateType === "Google Drive") {
return (
<>
<label>QAuth Credentials : </label>
<input value={defaultTemplateData.gdrive?.q_auth_credentials || ''} readOnly />
<label>QAuth Code : </label>
<input value={defaultTemplateData.gdrive?.q_auth_code || ''} readOnly />
<label>Save Directory : </label>
<input value={defaultTemplateData.gdrive?.directory || ''} readOnly />
</>
);
}
}

if (selectedTemplate?.name === "AWS S3") {
return (
<>
<label>Bucket : </label>
<input
type="text"
name="bucket"
value={bucket}
onChange={this.handleInputChange}
//readOnly={!isEditable}
readOnly={isFormFilled["AWS S3"] && !isEditable}
style={{
backgroundColor: (isFormFilled["AWS S3"] && !isEditable) ? "#f0f0f0" : "#fff",
border: isEditable ? "2px solid #4caf50" : "1px solid #ccc",
paddingRight: "6px",
}}
/>
<label>Access Key : </label>
<input
type="text"
name="access_key"
value={access_key}
onChange={this.handleInputChange}
readOnly={isFormFilled["AWS S3"] && !isEditable}
style={{
backgroundColor: (isFormFilled["AWS S3"] && !isEditable) ? "#f0f0f0" : "#fff",
border: isEditable ? "2px solid #4caf50" : "1px solid #ccc",
paddingRight: "6px",
}}
/>
<label>Secret Key : </label>
<input
type="text"
name="secret_key"
value={secret_key}
onChange={this.handleInputChange}
readOnly={isFormFilled["AWS S3"] && !isEditable}
style={{
backgroundColor: (isFormFilled["AWS S3"] && !isEditable) ? "#f0f0f0" : "#fff",
border: isEditable ? "2px solid #4caf50" : "1px solid #ccc",
paddingRight: "6px",
}}
/>
<label htmlFor="region-select">Select a Region:</label>
<select
id="region-select"
name="selectedRegion"
value={selectedRegion}
onChange={this.handleInputChange}
disabled={isFormFilled["AWS S3"] && !isEditable}
>
<option value="" disabled>Select a Region</option>
{regions.map((region, idx) => (
<optgroup label={region.name} key={idx}>
  {region.subRegions.map((sub, subIdx) => (
    <option key={subIdx} value={sub.code}>
      {sub.name}
    </option>
  ))}
</optgroup>
))}
</select>

<div style={{ marginTop: '10px' }}>
{(!isFormFilled["AWS S3"] || isEditable) && (
<Button
onClick={this.handleSaveAWSCredentials}
variant="contained"
sx={{
padding: '6px 10px',
fontSize: '14px',
background: 'linear-gradient(145deg,rgb(69, 183, 81),rgb(87, 237, 132))',
boxShadow: 2,
'&:hover': {
background: 'linear-gradient(145deg,rgb(87, 197, 86),rgb(29, 170, 4))',
},
cursor: 'pointer',
}}
>
Save AWS Config
</Button>
)}
</div>
</>
);
}

if (selectedTemplate?.name === "Google Drive") {
return (
<>
<label>QAuth Credentials : </label>
<input
type="text"
name="q_auth_credentials"
value={q_auth_credentials}
onChange={this.handleInputChange}
readOnly={isFormFilled["AWS S3"] && !isEditable}
style={{
backgroundColor: (isFormFilled["AWS S3"] && !isEditable) ? "#f0f0f0" : "#fff",
border: isEditable ? "2px solid #4caf50" : "1px solid #ccc",
paddingRight: "6px",
}}
/>
<label>QAuth Code: </label>
<input
type="number"
name="q_auth_code"
value={q_auth_code}
onChange={this.handleInputChange}
readOnly={isFormFilled["AWS S3"] && !isEditable}
style={{
backgroundColor: (isFormFilled["AWS S3"] && !isEditable) ? "#f0f0f0" : "#fff",
border: isEditable ? "2px solid #4caf50" : "1px solid #ccc",
paddingRight: "6px",
}}
/>
<label>Save Directory : </label>
<input
type="number"
name="directory"
value={directory}
onChange={this.handleInputChange}
readOnly={isFormFilled["AWS S3"] && !isEditable}
style={{
backgroundColor: (isFormFilled["AWS S3"] && !isEditable) ? "#f0f0f0" : "#fff",
border: isEditable ? "2px solid #4caf50" : "1px solid #ccc",
paddingRight: "6px",
}}
/>
{/* <label htmlFor="region-select">Select a Region:</label>
<select
id="region-select"
value={selectedRegion}
onChange={this.handleChange}
>
<option value="" disabled>Select a Region</option>
{regions.map((region, idx) => (
<optgroup label={region.name} key={idx}>
  {region.subRegions.map((sub, subIdx) => (
    <option key={subIdx} value={sub.code}>
      {sub.name}
    </option>
  ))}
</optgroup>
))}
</select> */}
</>
);
}

if (selectedTemplate?.name === "Dropbox") {
<>
<label>App Key (Client ID): </label>
<input
type="text"
name="dropbox_app_key"
value={this.state.dropbox_app_key}
onChange={this.handleInputChange}
readOnly={isFormFilled["Dropbox"] && !isEditable}
/>

<label>App Secret (Client Secret): </label>
<input
type="password"
name="dropbox_app_secret"
value={this.state.dropbox_app_secret}
onChange={this.handleInputChange}
readOnly={isFormFilled["Dropbox"] && !isEditable}
/>

<label>Access Token: </label>
<input
type="text"
name="dropbox_access_token"
value={this.state.dropbox_access_token}
onChange={this.handleInputChange}
readOnly={isFormFilled["Dropbox"] && !isEditable}
/>

<label>Save Directory: </label>
<input
type="text"
name="dropbox_directory"
value={this.state.dropbox_directory}
onChange={this.handleInputChange}
readOnly={isFormFilled["Dropbox"] && !isEditable}
/>
</>
}


})()}



                        </div>
                                 {/* )} */}
                                    {/* Control icon visibility based on state */}
                                    {

                                     isEditable ? (
                                        <div style={{display:'flex', alignItems:'center', gap:'15px', marginTop:'5px'}}>

                                            <img
                                                src={ResetIcon} // Replace with your circular arrow icon path
                                                alt="Reset"
                                                title="Reset"
                                                style={{ width: '22px', height: '22px', verticalAlign: 'middle', cursor: 'pointer' }}
                                                onClick={this.resetToFetchedData}
                                            />
                                        </div>
                                    ) : (
                                        <div style={{display:'flex', alignItems:'center', gap:'15px'}}>
                                            <img
                                                src={EditTemplate}
                                                alt="Edit template"
                                                title="Edit"
                                                style={{ width: '33px', height: '33px', cursor: 'pointer' }}
                                                onClick={this.handleEditTemplate}
                                            />

                                        </div>
                                    )}

                        <DialogBox
                            confirmDialog={confirmDialog}
                            setConfirmDialog={(updatedDialog) =>
                                this.setState({ confirmDialog: updatedDialog })
                            }
                            // onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
                            // onCancel={this.closeDialog}
                        />
                    </div>
                    <div style={{padding: '10px' }}>
                            <div className="form-section" style={{fontFamily: "Arial, sans-serif", fontSize:'14px'}}>
                                <h4>How it works?</h4>
                                <p><span style={{color:'lightseagreen'}}>Default Template :</span> <br/>
                                Selecting this template will store all the live stream data on our secure server by default.
    This requires no additional configuration and is ideal for users who do not have their own cloud storage.<br/><br/>
                                <span style={{color:'lightseagreen'}}>AWS-S3:</span> <br/>
                                Selecting this option allows you to store all live stream-related data on your own AWS S3 cloud storage bucket.
    You will be required to provide the necessary information.<br/><br/>
                                <span style={{color:'lightseagreen'}}>Google Drive:</span> <br/>
                                Selecting this option allows you to store all live stream-related data on your own Google Drive storage .
    You will be required to provide the necessary information.<br/><br/>
                                <span style={{color:'lightseagreen'}}>Important Notes:</span><br/>
    • From the 'Sites' tab further navigating to Device Info page, you can activate this storage facility<br/>
    • Only one template can be active at a time.<br/>
    • Switching templates will override the current storage configuration.<br/>
    • Ensure that the credentials provided for AWS S3 are valid and have necessary permissions (read/write).<br/>
    • Data stored using the default template is hosted securely but may be subject to your plan’s storage limits.<br/><br/>
                                <span style={{color:'lightseagreen'}}>Use Case Recommendations:</span><br/>
    • <strong>Use Default</strong> if you want a plug-and-play setup with no external configuration.<br/>
    • <strong>Use AWS-S3</strong> if your organization requires control over data residency, retention, or custom backup policies.<br/>

                                </p>
                            </div>
                    </div>
                </div>
            </div>
        )
    }
    }
    export default CloudStorageTemplates;
